'use client'
import { useStoredAccessToken } from '@/services/getoken'
import { Center, Modal, Text } from '@mantine/core'
import { RiCloseLine } from '@remixicon/react'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import Celebrations from 'public/images/Celebrations.png'
import { useRouter } from 'next/navigation'

function SignUp() {
  const [opened, setOpened] = useState(false)
  const router = useRouter()

  const token = useStoredAccessToken()
  const isLogin = Boolean(token)

  // Show popup only once per session
  useEffect(() => {
    if (isLogin) return

    // Check if popup was already shown in this session
    const alreadyShown = sessionStorage.getItem('signup_popup_shown')
    if (alreadyShown) return

    // Trigger popup after delay
    const timer = setTimeout(() => {
      setOpened(true)
      sessionStorage.setItem('signup_popup_shown', 'true')
    }, 500)

    return () => clearTimeout(timer)
  }, [isLogin])

  // Close popup + mark as shown
  const handleClose = () => {
    setOpened(false)
    sessionStorage.setItem('signup_popup_shown', 'true')
  }

  const handleSignupClick = () => {
    handleClose()
    router.push(`${process.env.NEXT_PUBLIC_WEBSITE_URL}/sso/signup`)
  }

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      withCloseButton={false}
      centered
      size='416px'
      overlayProps={{
        backgroundOpacity: 0.4,
        blur: 2,
      }}
      classNames={{
        content: 'h-[340px] rounded-xl text-center p-6',
      }}
    >
      {/* Close button in corner */}
      <button
        type='button'
        onClick={handleClose}
        aria-label='Close'
        className='absolute top-6 right-8 text-[#191919] cursor-pointer'
      >
        <RiCloseLine size={20} aria-hidden='true' />
      </button>

      {/* Emoji */}
      <Center mb='md'>
        <div className='bg-[#9D9D9D17] h-[68px] w-[68px] p-2.5 rounded-full flex items-center justify-center'>
          <Image src={Celebrations} alt='celebration' width={28} height={28} />
        </div>
      </Center>

      <Text fw={600} c='#101828' fz='18px' mb='sm'>
        Sign up now and see an automatic <br /> 15% off your stay!
      </Text>

      <Text c='#898989' fz='14px' mb='lg'>
        Join thousands of travelers who save more with Partment Stays. Unlock
        exclusive deals and premium benefits.
      </Text>
      {/* CTA Button */}
      <div
        onClick={handleSignupClick}
        role='button'
        tabIndex={0}
        style={{ backgroundColor: '#191919', height: '40px' }}
        className='flex items-center justify-center text-white font-semibold  text-[12px] text-md w-full rounded-lg border-none outline-none focus:outline-none shadow-[#1018280D] cursor-pointer select-none'
        onKeyDown={(e) => e.key === 'Enter' && handleSignupClick()}
      >
        Sign up now
      </div>
    </Modal>
  )
}

export default SignUp
